module.exports = __webpack_public_path__ + "img/allSprites.e73cf4e2.png";